/**
 * Recipient-picker empty-state rules for the DM composer.
 * Selected chips are filtered out of the remaining list, so an empty
 * remainder after a selection is not "no connections yet".
 */

export function shouldShowDmRecipientEmptyState(args: {
  loading: boolean;
  remainingCount: number;
  hasSearch: boolean;
  selectedCount: number;
}): boolean {
  if (args.loading || args.remainingCount > 0) return false;
  return args.hasSearch || args.selectedCount === 0;
}

export function shouldShowDmRecipientMenu(args: {
  open: boolean;
  loading: boolean;
  remainingCount: number;
  showEmptyMessage: boolean;
}): boolean {
  return args.open && (args.loading || args.remainingCount > 0 || args.showEmptyMessage);
}
